<template>
  <v-list three-line>
    <div three-line v-for="(order, index) in orders" :key="index">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>{{ order.company.name }}</v-list-item-title>
          <v-list-item-subtitle>PO # {{ order.poNum }}</v-list-item-subtitle>
          <v-list-item-subtitle>
            {{ moment(order.orderDate).format("MM-DD-YYYY") }}
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            {{ order.formattedOrderTotal }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn @click="viewOrder(order)" color="primary">View</v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-divider v-if="index + 1 < orders.length" />
    </div>
    <v-list-item v-if="!orders.length">
      <v-list-item-content>
        <v-list-item-title>There are no pending orders.</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import moment from "moment";
export default {
  name: "PendingOrders",
  props: {
    orders: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      moment,
    };
  },
  methods: {
    viewOrder(order) {
      this.$router.push({
        name: "AssociateOrder",
        params: {
          id: order._id,
        },
      });
    },
  },
};
</script>

<style scoped></style>
